import { CommonModule } from '@angular/common'
import { ModuleWithProviders, NgModule, inject } from '@angular/core'
import {
  FeatureFlagAsyncConfiguration,
  FeatureFlagConfiguration,
  FEATURE_FLAG_CONFIG,
  FEATURE_FLAG_FACTORY,
  launchDarklyFactory,
} from './feature-flag.core'
import { FeatureFlagService } from './feature-flag.service'

@NgModule({
  declarations: [],
  exports: [],
})
export class FeatureFlagDirectiveModule {}

@NgModule({
  imports: [CommonModule],
  providers: [FeatureFlagService],
})
export class FeatureFlagModule {
  protected service = inject(FeatureFlagService)

  constructor() {
    const service = this.service
    const parentModule = inject(FeatureFlagModule, {
      optional: true,
      skipSelf: true,
    })
    if (parentModule) {
      throw new Error('FeatureFlagModule is already loaded')
    }
    service.init()
  }

  public static forRoot(
    config: FeatureFlagConfiguration
  ): ModuleWithProviders<FeatureFlagModule> {
    return {
      ngModule: FeatureFlagModule,
      providers: [
        FeatureFlagService,
        {
          provide: FEATURE_FLAG_FACTORY,
          useFactory: launchDarklyFactory,
          deps: [FEATURE_FLAG_CONFIG],
        },
        {
          provide: FEATURE_FLAG_CONFIG,
          useValue: config,
        },
      ],
    }
  }

  public static forRootAsync(
    config: FeatureFlagAsyncConfiguration
  ): ModuleWithProviders<FeatureFlagModule> {
    return {
      ngModule: FeatureFlagModule,
      providers: [
        FeatureFlagService,
        {
          provide: FEATURE_FLAG_CONFIG,
          useFactory: () => config.useFactory,
        },
        {
          provide: FEATURE_FLAG_FACTORY,
          useFactory: launchDarklyFactory,
          deps: [FEATURE_FLAG_CONFIG],
        },
      ],
    }
  }

  public static forFeature(): ModuleWithProviders<FeatureFlagDirectiveModule> {
    return {
      ngModule: FeatureFlagDirectiveModule,
    }
  }
}
